import * as Sentry from '@sentry/react'
import { useRoutes } from 'react-router-dom'

import { routes } from './routes'

if (import.meta.env.PROD) {
  Sentry.init({
    dsn: 'https://993fa3e0e876a648cadf6077b5a1bafe@o44447.ingest.us.sentry.io/4509721568018432',
    // Setting this option to true will send default PII data to Sentry.
    // For example, automatic IP address collection on events
    sendDefaultPii: true,
  })
}

export const App = () => {
  const element = useRoutes(routes)

  return element
}
